var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockhistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9261 17.3652C28.5013 21.3562 26.2402 25.096 22.4984 27.2564C16.2816 30.8456 8.33225 28.7156 4.74302 22.4989L4.36073 21.8368M3.07276 14.6346C3.49756 10.6437 5.75885 6.90388 9.50065 4.74354C15.7173 1.15431 23.6668 3.28432 27.256 9.50105L27.6383 10.1632M2.9917 25.2757L4.11113 21.098L8.28884 22.2174M23.7102 9.78246L27.888 10.9019L29.0073 6.72416M15.9995 9.11876V16L19.8223 18.2937",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockhistory);
export default __webpack_public_path__ + "static/media/clockhistory.3cc24fe150d870b596c8149e90089416.svg";
export { ForwardRef as ReactComponent };